import React, {useState, useEffect} from 'react';
import SelectInterface from '../../forms/SelectInterface.js';
import FieldInterface from './form.js';
import api from '../../../api/index.js';
import {usePrevious, callback} from '../../../helpers.js';

const FieldInterfaceWrapper = (props) => {
	console.log(props);
	return React.createElement(FieldInterface, {
		...props.data.source,
		onAdded: props.onSubmit,
		onUpdated: props.onSubmit
	});
}

// The farms endpoint doesn't include fields and the fields endpoint is under farms...

const FieldSelector = (props) => {

	const [fields, setFields] = useState(false);
	const endpoint = 'fields?from=' + new Date(props.from).api() + '&until=' + new Date(props.until).api();
	// Check on this...


	const refresh = async () => {
		try {
			// If it has changed, it'll already have been invalidated so getsoft() is safe here
			let data = await api.getsoft(endpoint);
			setFields(data);
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	const prevProps = usePrevious(props);

	// Refresh if the date has changed
	useEffect(() => {
		if (!prevProps) return;
		if (fields !== false && (prevProps.from !== props.from || prevProps.until !== props.until)) {
			refresh();
		}
	}, [props]);

	// Refresh on initial load
	useEffect(() => {
		if (fields === false) { // *** Or previous date prop isn't the same as current date prop
			refresh();
		}

		// If employees have changed, refresh the data
		api.addEventListener('field.change', refresh);
		return ()=>{
			api.removeEventListener('field.change', refresh);
		}
	});


	const onChange = (e) => {
		callback(props.onChange, [e.value])
	}
	
	const onEditSubmit = (e) => {
		api.invalidate(endpoint);
		api.call('field.change'); // The data has changed - refresh it (for all of them)
		return true;
	}
	
	const onAddSubmit = (e) => {
		api.invalidate(endpoint);
		api.call('field.change'); // The data has changed - refresh it (for any visible)
		return true;
	}
	
	const id2value = (id) => {
		if (fields) {
			for(let i=0; i < fields.length; i++) {
				if (fields[i].FieldID === id)
					return {
						'value': fields[i].FieldID,
						'label': fields[i].FieldNumber,
						'group': fields[i].FarmName,
						'source': fields[i],
					};
			}
		}
		return {};
	}


	const group = (data) => {
		let groups = {};
		data.forEach((x)=>{
			if (!groups.hasOwnProperty(x.FarmName))
				groups[x.FarmName] = {
					'label': x.FarmName,
					'options': []
				};
			groups[x.FarmName]['options'].push({
				'value': x.FieldID,
				'label': x.FieldNumber,
				'group': x.FarmName,
				'source': x
			});
		});
		//console.log(Object.values(groups));
		return Object.values(groups);
	}

	// Search needs to search group
	return <SelectInterface 
		placeholder={props.placeholder || "Field"}
		onEditSubmit={onEditSubmit}
		onAddSubmit={onAddSubmit}
		value={id2value(props.field)}
		options={fields ? group(fields) : []}
		type={"Field"}
		onChange={onChange}
		editForm={FieldInterfaceWrapper}
		addForm={FieldInterfaceWrapper}
		showClear={props.showClear}
	/>

}
export default FieldSelector;